export default {
  insertMenuTitle: 'Expression menu',
};
